import {
  LAMBDATEST_TEST_STREAM_LOADING,
  LAMBDATEST_TEST_STREAM_SUCCESS,
  LAMBDATEST_TEST_STREAM_FAILED,
  LAMBDATEST_TEST_STREAM_CLEAR,
  LAMBDATEST_TEST_RESET_STREAM_DRAWER,
  SWITCH_LIVE_INTERACTION,
  CHANGE_LIVE_STREAM_TYPE,
  SET_CROPPED_VIDEO,
  RESET_CROPPED_VIDEO,
} from '../actionTypeConstants/LambdaTestLiveStreamConstants';
import { StreamingClients } from '../../constants/streamingConstants';

const initialState = {
  client: StreamingClients.WEBRTC,
  stream: {
    loading: false,
    data: {},
    error: null,
  },
  webrtc: {
    takeOffReceived: false,
    metaInfo: {
      width: 0,
      height: 0,
    },
    disconnectStreamingMessage: 0,
    lastMove: null,
    invokeUpdateScaleMessage: 0,
    dataChannelMessage: '',
    resetVideoStreamMessage: '',
    connectStreamingUrlMessage: '',
    idle_timeout: 1,
    testTakeoffData: null,
    currentTestState: {},
  },
  showLiveInteraction: false,
  showLiveInteractionDrawer: false,
  isCroppedVideo: true,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_TEST_STREAM_LOADING:
      return { ...state, stream: { ...state.stream, loading: true, data: {} } };
    case LAMBDATEST_TEST_STREAM_SUCCESS:
      return {
        ...state,
        stream: {
          ...state.stream,
          loading: false,
          data: action.result.data,
          error: null,
        },
      };

    case LAMBDATEST_TEST_STREAM_FAILED:
      return {
        ...state,
        stream: { ...state.stream, loading: false, error: action.error },
      };

    case LAMBDATEST_TEST_STREAM_CLEAR:
      return {
        ...state,
        stream: initialState.stream,
      };

    case SET_CROPPED_VIDEO: {
      return {
        ...state,
        isCroppedVideo: action.result,
      };
    }

    case RESET_CROPPED_VIDEO: {
      return {
        ...state,
        isCroppedVideo: initialState.isCroppedVideo,
      };
    }

    case LAMBDATEST_TEST_RESET_STREAM_DRAWER:
      return {
        ...state,
        showLiveInteractionDrawer: false,
        showLiveInteraction: false,
      };

    case SWITCH_LIVE_INTERACTION:
      return { ...state, showLiveInteraction: action.result };

    case 'SET_TAKE_OFF_RECEIVED': {
      return {
        ...state,
        webrtc: {
          ...state.webrtc,
          takeOffReceived: action.result,
        },
      };
    }

    case 'SET_LAST_MOVE': {
      return {
        ...state,
        webrtc: {
          ...state.webrtc,
          lastMove: action.result,
        },
      };
    }

    case 'SET_DRAWER': {
      return {
        ...state,
        showLiveInteractionDrawer: action.result,
      };
    }

    case CHANGE_LIVE_STREAM_TYPE: {
      return {
        ...state,
        client: action.result,
      };
    }

    default:
      return state;
  }
}
